'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.masterPortal = document.querySelector('.ui-lib-master-portal');

      if (this.masterPortal === null) {
        this.masterPortal = document.createElement('div');
        this.masterPortal.classList.add('ui-lib-master-portal');
        document.body.appendChild(this.masterPortal);
      }

      this.popup = document.createElement('div');
      this.popup.classList.add('ui-lib-portal');
      this.masterPortal.appendChild(this.popup);

      this.renderLayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _reactDom2.default.unmountComponentAtNode(this.popup);
      this.masterPortal.removeChild(this.popup);
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.popup);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(_react.Component);

Portal.propTypes = {
  children: _propTypes2.default.node };

exports.default = Portal;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Portal.js
// module id = 584
// module chunks = 0